import React from "react";

import { Grid, TableBody, TableCell, TableRow } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

import { TableCard } from "@hubcapp/components";

const LessonPreferencesSkeleton: React.FC<{ title: string }> = ({ title }) => (
  <TableCard title={title}>
    <TableBody>
      <TableRow>
        <TableCell>
          <Skeleton width="60%" height="40px" />
          <Skeleton width="100%" height="90px" />
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell>
          <Grid container spacing={3}>
            <Grid item xs>
              <Skeleton width="100%" height="60px" />
            </Grid>
            <Grid item xs>
              <Skeleton width="100%" height="60px" />
            </Grid>
            <Grid item>
              <Skeleton variant="circle" width="60px" height="60px" />
            </Grid>
          </Grid>
        </TableCell>
      </TableRow>
    </TableBody>
  </TableCard>
);

export default LessonPreferencesSkeleton;
